import { CommunityType } from 'src/utils/datahubDefaultEvent'

export type PathParams = {
  lang: string
  membership: string
}

export const CommunityTypeConsume = {
  1: CommunityType.PUBLIC,
  2: CommunityType.PRIVATE,
  3: CommunityType.PREMIUM,
  4: CommunityType.PAID
}
